import { render, staticRenderFns } from "./MatchPageFooter.vue?vue&type=template&id=5adf6230&scoped=true"
import script from "./MatchPageFooter.vue?vue&type=script&lang=js"
export * from "./MatchPageFooter.vue?vue&type=script&lang=js"
import style0 from "./MatchPageFooter.vue?vue&type=style&index=0&id=5adf6230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf6230",
  null
  
)

export default component.exports